import React from 'react'
import {TbCircleDotFilled} from 'react-icons/tb'
import Button from '../Component/Button';

function Projects() {

        const handleWhatsAppClick = (projName) =>{

            const phoneNum = '+237653886282'; 
            const defaultMessage =`Care to share more about this ${projName} project?`;
            const url =  `https://api.whatsapp.com/send?phone=${phoneNum}&text=${defaultMessage}`
            window.open(url)
        }


  return (
    <>
        <div className='py-10 bg-orange-300'>

            <div className='w-[90%] max-w-[1280px] mx-auto'>
            <div className='flex flex-row gap-5 mb-5 items-center'>
                    
                    <TbCircleDotFilled  className='text-[2rem] text-white'/> 
                    <h3 className='inline text-[2rem] font-bold font-mada text-white'>Projects</h3>
                </div>
                    <div className='mx-auto md:w-85 flex justify-center flex-col'>
                        <div className='sm:flex sm:flex-row gap-2 justify-center'>
                            <div className=' sm:w-[47%] md:w-[50%] px-0 py-0 mb-10 md:mb-0 md:px-5 md:py-5'>
                                <img src='/img/fampl.jpg' className='w-80 mb-4 md:w-full object-cover'   alt='family planing'/>
                                <h6 className='font-bold text-[1.2rem] md:text-[1.5rem] font-lato text-yellow-700'>Family Planning Method: </h6>
                                <p className=' mt-3 text-[1rem] md:text-justify font-mada leading-[1.5rem]'>
                                Empowering women through family planning is a crucial step in our fight against gender-based violence and our advocacy for gender equality. By offering women control over their reproductive choices, we enable them to build stronger, more independent futures. This approach not only protects their rights but also paves the way for a more inclusive and equitable society. As we tackle the root causes of GBV, our family planning program stands as a vital tool for lasting change and empowerment. Together, we can create a brighter future for all.
                                </p>
                                <div className='mt-3'>
                                <Button children='Learn More' bgColor='bg-orange-600' onclick={()=>handleWhatsAppClick('Family Planning')} />
                                </div>
                                
                            </div>
                            <div className='sm:w-[47%] md:w-[50%] px-0 py-0 md:px-5 md:py-5'>
                                <img src='/img/ante.jpg' className='w-80 mb-4 md:w-full  object-cover'  alt='family planing'/>
                                <h6 className='font-bold text-[1.2rem] md:text-[1.5rem] font-lato text-yellow-700'>Antenatal, Prenatal Support: </h6>
                                <p className=' mt-3 text-[1rem] md:text-justify font-mada leading-[1.5rem]'>
                                Our commitment to promoting maternal health and supporting expectant mothers is central to our mission to combat gender-based violence. By ensuring a nurturing environment for pregnant women, we empower them to navigate this critical time with confidence and security. This dedication safeguards their well-being and advances gender equality. Through antenatal and prenatal support, we strive to build a safer, more compassionate society. Together, we can make a lasting impact on women and their families.
                                </p>
        
                                <div className='mt-3'>
                                <Button children='Learn More' bgColor='bg-orange-600' onclick={()=>handleWhatsAppClick('Antenatal')} />
                                </div>
                                
                            </div>
                        </div>
                        
                    </div>
            </div>
       
        </div>
    </>
  )
}

export default Projects
